<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <label v-for="(option, index) in field.options" :key="index" :for="'id_' + field.id + '_i_' + index" class="control checkbox">
      <input :name="field.name + index" v-if="!field.multi" :checked="value === option.value" :value="option.value" @change="$emit('input', $event.target.value);$emit('change', '')" type="checkbox" :id="'id_' + field.id + '_i_' + index" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :required="field.required">
      <input :name="field.name + index" v-if="field.multi" :checked="value.indexOf(option.value) > -1" :value="option.value" @change="multiCheck($event.target.value, fieldIndex);$emit('change', '')" type="checkbox" :id="'id_' + field.id + '_i_' + index" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :required="field.required">
      <span class="control-indicator"></span>
      <span class="control-label">{{ option.label[currentLanguage] }}</span>
    </label>
    <p class="small" v-if="field.description[currentLanguage]">{{ field.description[currentLanguage] }}</p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'fieldIndex', 'multiCheck']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/checkbox.vue